import { Component, Injector, ViewEncapsulation, ViewChild, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {
    OrderGuideSimpleDto, VDBServiceProxy, VirtualDbRowDto,
} from '@shared/service-proxies/service-proxies';
import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';

import { BehaviorSubject, throwError, of, Subscription } from "rxjs";

import { appModuleAnimation } from '@axilla/axilla-shared';
import * as _ from 'lodash-es';
import moment from 'moment';
import { filter, take, finalize } from 'rxjs/operators';

import { Table } from 'primeng/table';
import { Paginator } from 'primeng/paginator';
import { LazyLoadEvent } from 'primeng/api';

import { WebshopService } from '@app/shared/common/shop-system/services/webshop.service';
import { AppConsts } from "@shared/AppConsts";


@Component({
    selector: 'app-webshop-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.less'],
    encapsulation: ViewEncapsulation.None,
})
export class WebshopBannerComponent extends AppComponentBase implements OnInit {

    @Input() bannerName?: string;
    @Input() selected?: any;

    get orderGuide(): OrderGuideSimpleDto[] {
        return this._webshopService.orderGuides;
    }
 

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    constructor(
        injector: Injector,

        private _webshopService: WebshopService,
    ) {
        super(injector);
    }

    ngOnInit(): void {

       
    }


    getBannerUrl() {

        if (this.bannerName) {
            let splitted = this.bannerName.split('_');

            let og = splitted[0];
            let pictureNumber = splitted[1];

            return this.remoteServiceBaseUrl + '/TenantCustomization/GetOrderGuideBanner/' + this.appSession.tenant.id + '/' + og + '/' + pictureNumber;
        }
    }

}

